@if (!options?.hideHeader) {
  <div class="modal-header {{ options?.headerClass }}">
    <h3 class="modal-title w-100 {{titleAlignment}}">
      {{ options?.title }}
    </h3>
    @if (options?.titleFloatingContent) {
      <div class="modal-floating-title-content">
        @if (titleFloatingContentIsHtmlString) {
          <div [innerHTML]="options!.titleFloatingContent"></div>
        } @else {
          <ng-component *ngTemplateOutlet="$any(options!.titleFloatingContent)" />
        }
      </div>
    }
    @if (!options?.hideTopClose) {
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        data-testid="modal_close_btn"
        (click)="cross()"
      >
      </button>
    }
  </div>
}

<div
  class="modal-body"
  (scroll)="onScroll($event)"
>
  @if (options?.message) {
    <div [innerHTML]="options!.message"></div>
  }

  @if (options?.template) {
    <div class="container-fluid">
      <ng-container *ngTemplateOutlet="options!.template; context: options!.template.data" />
    </div>
  }
</div>

@if (options?.showButtons) {
  <div class="modal-footer">
    @if (!options!.hideSubmit) {
      <button
        data-testid="modal_submit_btn"
        type="button"
        class="btn btn-colour-blue-600"
        [disabled]="isDisabled"
        (click)="yes()"
      >
        {{ options!.okLabel || 'Save' }}
      </button>
    }
    @if (!options!.hideCancel) {
      <button
        data-testid="modal_cancel_btn"
        type="button"
        class="btn btn-outline-colour-grayscale-900"
        (click)="no()"
      >
        {{ options!.cancelLabel || 'Cancel' }}
      </button>
    }
  </div>
}
